import { useEffect } from "react";
import {
    ANALYTICS_CONSENT_EVENT,
    ANALYTICS_PAGE_EVENT,
    hasAnalyticsConsent,
    trackAnalytics,
    AnalyticsEvent
} from "utils/analytics";

function useAnalyticsView(
    event: AnalyticsEvent,
    flow: "classic" | "public_checkout" | "dashboard",
    step?: string,
    restaurantId?: string,
    outcome?: string
) {
    useEffect(() => {
        let tracked = false;
        const capture = () => {
            if (!hasAnalyticsConsent()) {
                tracked = false;
                return;
            }
            if (tracked) return;
            tracked = trackAnalytics(event, {
                flow,
                step,
                restaurant_id: restaurantId,
                outcome
            });
        };
        capture();
        window.addEventListener(ANALYTICS_CONSENT_EVENT, capture);
        window.addEventListener(ANALYTICS_PAGE_EVENT, capture);
        return () => {
            window.removeEventListener(ANALYTICS_CONSENT_EVENT, capture);
            window.removeEventListener(ANALYTICS_PAGE_EVENT, capture);
        };
    }, [event, flow, step, restaurantId, outcome]);
}

export default function useAnalyticsStep(
    flow: "classic" | "public_checkout" | "dashboard",
    step: string,
    restaurantId?: string
) {
    useAnalyticsView(
        flow === "dashboard"
            ? "dashboard_reservation_step_viewed"
            : "booking_step_viewed",
        flow,
        step,
        restaurantId
    );
}

export function useAnalyticsResult(
    flow: "classic" | "public_checkout",
    outcome: string,
    restaurantId?: string
) {
    useAnalyticsView(
        "booking_result_viewed",
        flow,
        undefined,
        restaurantId,
        outcome
    );
}
